<template>

  <head>

    <meta charset="utf-8" />
    <title>Hotline Transporters Sacco | Zone Targets</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">


    <NavigationBar/>


    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Zone Targets</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Set Ups</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Revenue Targets</a></li>
                    <li class="breadcrumb-item active">Zone Targets</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>

          <!-- tool bar -->
          <ToolBarTargets/>
          <!-- end of toolbar -->

          <!-- Filter Section -->
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="card">
                <div class="card-body">
                  <label><strong>Filter by Sub County</strong></label>
                  <select v-model="selectedSubCounty" @change="filterZonesBySubCounty" class="form-select">
                    <option value="">All Sub Counties</option>
                    <option v-for="subCounty in subCounties" :key="subCounty.subCountyID" :value="subCounty.subCountyID">
                      {{subCounty.subCountyName}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- end page title -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div
                    class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100"
                       role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input type="text" v-model="searchQuery"
                                 class="form-control bg-light border-light rounded"
                                 placeholder="Search zone..." fdprocessedid="husj3l">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">

                      <button data-bs-toggle="modal" data-bs-target=".updownload-modal"
                              type="button"
                              class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="mdi mdi-microsoft-excel font-size-16"></i> <span
                          class="pl-1 d-md-inline">Upload Excel File</span>
                      </button>

                      <button data-bs-toggle="modal" data-bs-target=".download-modal"
                              type="button"
                              class="btn btn-success dropdown-toggle option-selector me-3 text-capitalize ">
                        <i class="dripicons-download font-size-16"></i> <span
                          class="pl-1 d-md-inline">Download</span>
                      </button>

                    </div>


                  </div>

                </div>
                <div class="card-body">
                  <div class="table-responsive overflow-visible">

                    <table class="table align-middle table-hover  contacts-table" id="">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th>#</th>
                        <th scope="col">Zone</th>
                        <th>Sub County</th>
                        <th>Ward</th>
                        <th class="text-right">Daily Target</th>
                        <th class="text-right">Monthly Target</th>
                        <th class="text-right">Financial Year Target</th>
                        <th></th>

                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" :value="item" v-for="(item, index) in filteredZones">
                        <th>{{index+1}}.</th>

                        <td class="">
                          {{item.zone}}
                        </td>
                        <td>
                          {{item.subCountyName}}
                        </td>
                        <td>
                          {{item.wardName}}
                        </td>
                        <td class="text-right">
                          KES {{numberFormat(item.dailyTargets || 0)}}
                        </td>
                        <td class="text-right">
                          KES {{numberFormat(item.monthlyTargets || 0)}}
                        </td>
                        <td class="text-right">
                          KES {{numberFormat(item.FYTarget || 0)}}
                        </td>

                        <td>
                          <button @click="selectedZone(item)" data-bs-toggle="modal" data-bs-target=".target-modal"
                                  class="btn btn-primary btn-sm"><i
                              class="mdi mdi-file-document-edit-outline"></i>
                            Edit</button>
                        </td>
                      </tr>

                      </tbody>

                    </table>
                  </div>

                </div>

                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation example "
                       class="d-flex align-items-center justify-content-between">

                    <div class="d-flex align-items-center">
                                            <span class="pr-3 pb-0 mb-0 font-13px">
                                                <span>Rows Per Page</span>
                                            </span>
                      <select v-model="rowsPerPage" @change="updatePagination" class="form-select w-auto font-13px ">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                        <option value="150">150 Rows</option>
                        <option value="200">200 Rows</option>
                      </select>
                    </div>

                    <ul class="pagination">
                      <li class="page-item" :class="{disabled: currentPage === 1}">
                        <a class="page-link" @click="previousPage" href="javascript: void(0);" tabindex="-1">Previous</a>
                      </li>
                      <li class="page-item" v-for="page in totalPages" :key="page" :class="{active: page === currentPage}">
                        <a class="page-link" @click="goToPage(page)" href="javascript: void(0);">{{page}}</a>
                      </li>
                      <li class="page-item" :class="{disabled: currentPage === totalPages}">
                        <a class="page-link" @click="nextPage" href="javascript: void(0);">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- upload modal -->
      <div class="modal fade updownload-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Zone Targets Upload</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <address>
                    <strong class="text-capitalize">Revenue Target for The Year</strong><br>
                    2023/2024
                  </address>
                </div>

                <div class="col-12">
                  <address>
                    <strong class="text-capitalize">Sample Excel Sheet</strong><br>
                    <p><a href="javascript: void(0);"><i class="mdi mdi-download"></i> Download Sample Excel File</a>
                    </p>
                  </address>
                </div>

                <div class="col-12">
                  <label><strong>Select the file</strong></label>
                </div>
                <div class="col-12">
                  <div>
                    <form action="#" class="dropzone">
                      <div class="fallback">
                        <input name="file" type="file" multiple="multiple">
                      </div>
                      <div class="dz-message needsclick">
                        <div class="mb-3">
                          <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                        </div>

                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </form>
                  </div>
                </div>



                <div class="col-12">
                  <button type="button"
                          class="btn btn-primary dropdown-toggle option-selector text-capitalize w-100 mt-5">
                    <i class="bx bxs-download  font-size-16"></i> <span
                      class="pl-1 d-md-inline">Upload Excel File</span>
                  </button>
                </div>

              </div>

            </div>

          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of upload modal -->

      <!-- setting target -->
      <div class="modal fade target-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Collections Targets for {{zone.zone}} Zone</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">

                <div class="col-12 mb-3">
                  <address>
                    <strong>Zone Details:</strong><br>
                    Zone: {{zone.zone}}<br>
                    Sub County: {{zone.subCountyName}}<br>
                    Ward: {{zone.wardName}}
                  </address>
                </div>

                <!-- calculated by dividing FY target by 365 -->

                <div class="col-12">
                  <label><strong>Daily Target Amount</strong></label>
                </div>
                <div class="col-12 mb-3">
                  <input v-model="zone.dailyTargets" class="form-control" type="number" placeholder="Enter Amount">
                </div>

                <!-- calculated by dividing FY targets by 12 -->

                <div class="col-12">
                  <label><strong>Monthly Target</strong></label>
                </div>
                <div class="col-12 mb-3">
                  <input v-model="zone.monthlyTargets" class="form-control" type="number" placeholder="Enter Amount">
                </div>

                <!-- this is what has been provided -->

                <div class="col-12">
                  <label><strong>Financial Year Target</strong></label>
                </div>
                <div class="col-12 mb-3">
                  <input  v-model="zone.FYTarget" class="form-control" type="number" placeholder="Enter Amount">
                </div>



                <div class="col-12">
                  <button @click="updateZoneTargets()" type="button" data-bs-dismiss="modal"
                          class="btn btn-primary dropdown-toggle option-selector text-capitalize w-100 mt-5">
                    <i class="mdi mdi-content-save-all  font-size-16"></i> <span
                      class="pl-1 d-md-inline">Save Changes</span>
                  </button>
                </div>

              </div>

            </div>

          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of target setting -->

      <!-- download modaL -->
      <div class="modal fade download-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Download Zone Targets</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <address>
                    <strong class="text-capitalize">Report Title</strong><br>
                    Revenue Collections By Zones in  County
                  </address>
                </div>



                <div class="col-12">
                  <label><strong>Select File Type</strong></label>
                  <select class="form-select">
                    <option>Select Document Type</option>
                    <option>PDF file</option>
                    <option>Excel File</option>
                  </select>
                </div>

                <div class="col-12">
                  <button  type="button" class="btn btn-primary dropdown-toggle option-selector text-capitalize w-100 mt-5">
                    <i class="bx bxs-download  font-size-16"></i> <span class="pl-1 d-md-inline">Download Report</span>
                  </button>
                </div>

              </div>

            </div>

          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- END OF DOWNLOAD MODAL -->

      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">

            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                County Government
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>

  </body>


</template>

<script>

import ToolBarTargets from "@/components/systemsettings/ToolBarTargets";
import NavigationBar from "@/components/Navigation";
import {biller, execute} from "@/api";

export default {
  name: "TargetsZone",
  components: {NavigationBar, ToolBarTargets},
  data() {
    return {
      zones:[],
      filteredZones: [],
      subCounties: [],
      selectedSubCounty: '',
      searchQuery: '',
      zone: {
        zone: null,
        wardID: null,
        subCountyName: null,
        wardName: null,
        dailyTargets: 0,
        monthlyTargets: 0,
        FYTarget: 0
      },
      currentPage: 1,
      rowsPerPage: 25,
      totalPages: 1
    };
  },
  mounted() {
    this.getZoneTargets();
    this.getSubCounties();
    this.menuAccess();
  },
  computed: {
    paginatedZones() {
      const start = (this.currentPage - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      return this.filteredZones.slice(start, end);
    }
  },
  watch: {
    searchQuery() {
      this.filterZones();
    }
  },
  methods:{

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Targets Zone");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then(() => {
            // alert(res.data.message);
          })
          .catch(() => {
            // alert(e.message);
          });
    },

    selectedZone(item) {
      this.zone = {...item};
      // Ensure numeric values
      this.zone.dailyTargets = Number(this.zone.dailyTargets) || 0;
      this.zone.monthlyTargets = Number(this.zone.monthlyTargets) || 0;
      this.zone.FYTarget = Number(this.zone.FYTarget) || 0;
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    getZoneTargets() {
      const data = new FormData();
      data.append("function", "getZoneTargets");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.zones = res.data.data.zones;
              this.filteredZones = this.zones;
              this.updatePagination();
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties;
            }
          })
          .catch((e) => {
            console.error(e.message);
          });
    },

    updateZoneTargets() {
      const data = new FormData();
      data.append("function", "updateZoneTargets");
      data.append("zone", JSON.stringify(this.zone));
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.getZoneTargets();
              alert("Zone targets updated successfully!");
            } else {
              this.message = res.data.message;
              alert("Error updating targets: " + res.data.message);
            }
          })
          .catch((e) => {
            this.message = e.message;
            alert("Error: " + e.message);
          });
    },

    filterZones() {
      this.filteredZones = this.zones.filter(zone => {
        const matchesSearch = !this.searchQuery ||
            zone.zone.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
            zone.subCountyName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
            zone.wardName.toLowerCase().includes(this.searchQuery.toLowerCase());

        const matchesSubCounty = !this.selectedSubCounty ||
            zone.subCountyID === this.selectedSubCounty;

        return matchesSearch && matchesSubCounty;
      });
      this.currentPage = 1;
      this.updatePagination();
    },

    filterZonesBySubCounty() {
      this.filterZones();
    },

    updatePagination() {
      this.totalPages = Math.ceil(this.filteredZones.length / this.rowsPerPage) || 1;
      if (this.currentPage > this.totalPages) {
        this.currentPage = 1;
      }
    },

    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      this.currentPage = page;
    }
  }
}
</script>

<style scoped>

</style>